import request from '@/router/axios';

export const stathistoryDetail = (params) => {
  return request({
    url: '/api/blade-stat/stathistory/detail',
    method: 'get',
    params
  })
}

export const statregionDetail = (params) => {
  return request({
    url: '/api/blade-stat/statregion/statRegionAge',
    method: 'get',
    params
  })
}